import { createFileRoute } from '@tanstack/react-router';
import { Overview } from '@/components/overview';
import { useRBAC } from '@/hooks/use-rbac';
import { useCompany } from '@/hooks/use-company';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert, Loader2 } from 'lucide-react';

export const Route = createFileRoute('/(app)/owner/overview/')({
  component: OwnerOverviewPage,
});

function OwnerOverviewPage() {
  const { roleLevel, rbacEnabled } = useRBAC();
  const { isLoading: isLoadingCompanies } = useCompany();

  // Show loading state while company data is being fetched
  if (isLoadingCompanies) {
    return (
      <div className="container max-w-6xl py-8 space-y-6">
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground mb-4" />
            <p className="text-muted-foreground">Loading...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Page-level access control - Only L1 (Owner) can access overview page
  // L2 and L3 users are blocked
  if (rbacEnabled && roleLevel !== 1) {
    return (
      <div className="container max-w-6xl py-8 space-y-6">
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <ShieldAlert className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
            <h3 className="text-lg font-medium">Access Denied</h3>
            <p className="text-muted-foreground mt-1 text-center">
              You don't have permission to access the overview page.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Overview />;
}
